import { ChessKnightIcon } from './ChessKnightIcon';

/**
 * author: Michael Richins
 * id 99D5E230-2040-4811-BEF1-17B867DA5F75
 * name chess-knight
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chess-knight.svg
 * tags
 * - Gaming / RPG 
 */
export const ChessHorseIcon = ChessKnightIcon;
export default ChessHorseIcon